/*
 * Фильтрующая функция для исключения значений, которые преобразуются в false при приведении к boolean.
 *
 * Метод фильтрует следующие значения:
 * - false
 * - 0 (ноль)
 * - '' (пустая строка)
 * - null
 * - undefined
 * - NaN
 *
 * Функция предназначена для использования с методом Array.filter() в случаях, когда необходимо:
 * - отфильтровать "ложные" значения из массива;
 * - получить только "правдивые" (truthy) элементы.
 *
 * Принцип работы основан на преобразовании значения через конструктор Boolean.
 *
 * Пример использования:
 * const filteredArray = [0, 1, '', 'hello', null, undefined, NaN].filter(filterFalsyValues);
 * // Результат: [1, 'hello']
 *
 * @param value Любое значение для проверки
 * @returns {boolean} true, если значение является truthy; false, если значение преобразуется в false
 */

export const filterEmpty = <T extends unknown>(item: T): item is Exclude<T, undefined | false | null | 0 | ''> =>
    Boolean(item);
